import React, {Component} from "react";

import SearchBox from "../../components/Search";
import Favorites from "../../components/Favorites"
import Modules from "../../components/Modules";

const Layer3 = () => {

        return <div className="layer3">
            <SearchBox />
            <Favorites />
            <Modules />
        </div>
}

export default Layer3;